import { FieldConfig } from '../dynamic-field/field.config';

export interface AutofillConfig {
    fields: Array<FieldConfig<any>>;
}
